import { toast } from "react-toastify";
import AttToken from "../../helpers/attToken";
import IUserData from "../../interface/IUserData";
import Anonimo from "../../service/Anonimo";
import Files from "../../service/Files";
import Execucoes from "../../service/Execucoes";
import {
  //  ChamadoChecklist,
   FormToFilling,
  //  ItemFormFilling,OcorrenciaType,SubItemFormFilling 
  } from "../../types/new-form-filling/types";
import { DownloadFilesResponse } from "../../types/user-card/types";

// const valores: "docs" | "empty" | "images" | "multimidia" = "docs";

const execucoesService = new Execucoes();
const anonimoService = new Anonimo();
const filesService = new Files();
type UploadStatusItem = { status?: number; files?: unknown[] };

async function generateUploadToken(
  token: { userToken: string; username: string; userEmpresa: string },
  amount: number,
  path: string,
): Promise<string> {
  const response = await filesService.generateUploadToken(token, amount, path);
  if (!response) {
    throw new Error("Erro ao gerar token de upload");
  }
  return response.t;
}

export async function uploadFilesV2(filesArray: File[], path: string, inicio?: number): Promise<DownloadFilesResponse | undefined> {
  const token = await AttToken();
  if (!token) {
    throw new Error("Token inválido");
  }
  const uploadToken = await generateUploadToken(token, filesArray.length, path);
  if (!uploadToken) {
    throw new Error("Erro ao gerar token de upload");
  }
  const files: File[] = [];
  files.push(...filesArray);
  const formData = new FormData();
  files.forEach((ele: File) => formData.append("files", ele));
  toast.info("Enviando arquivos...", { toastId: `uploadFilesV2-${inicio}` });
  const responseFiles = await filesService.uploadFilesV2(formData, uploadToken);
  const uploadResults = Object.entries(responseFiles?.data ?? {})
    .filter(([key, value]) => key !== "empty" || (value as UploadStatusItem)?.files?.length)
    .map(([, value]) => value as UploadStatusItem);

  if (uploadResults.some((item) => item.status && item.status > 399) || responseFiles?.status === 500) {
    toast.error("Erro ao enviar arquivos", { toastId: `uploadFilesV2-${inicio}` });
    throw new Error("Erro ao enviar arquivos");
  }
  if (uploadResults.some((item) => item.status === 200)) {
    toast.success("Arquivos enviados", { toastId: `uploadFilesV2-${inicio}` });
    return;
  }

  throw new Error("Upload não confirmado");
}

export async function executaForm(
  inicio: number,
  data: FormToFilling,
  logado?: boolean,
  files?: File[],
  selectedCliente?: { id: string; nome: string } | null,
  selectedConjunto?: { id: string; nome: string } | null,
  selectedLocal?: { id: string; nome: string } | null,
  selectedUnidade?: { id: string; nome: string } | null,
  userData?: IUserData,
  search?: string,
  pause = false,
  executionLease?: true,
) {
  if (logado) {
    const token = await AttToken();
    if (!token) {
      throw new Error("Token inválido");
    }
    if (token) {
      if (files && files.length > 0) {
        await uploadFilesV2(files, `checklisthistorico/${token.username}/${inicio}`, inicio);
      }
      const {
        chamadosConfig: _chamadosConfig,
        fim: _fim,
        pausa: _pausa,
        ultimaDataPausa: _ultimaDataPausa,
        expiraEm: _expiraEm,
        usuario: _usuario,
        ...checklistParaEnvio
      } = data as FormToFilling & { ultimaDataPausa?: number | null; expiraEm?: number | null };
      const body: Record<string, unknown> = {
        ...checklistParaEnvio,
        inicio: inicio,
        ...(pause
          ? { pausa: true }
          : { fim: Date.now(), pausa: false, expiraEm: null, ultimaDataPausa: null }),
        ...(selectedCliente ? { cliente: selectedCliente.id, nomeCliente: selectedCliente.nome } : {}),
        ...(selectedLocal ? { local: selectedLocal.id, nomeLocal: selectedLocal.nome } : {}),
        ...(selectedConjunto ? { conjunto: selectedConjunto.id, nomeConjunto: selectedConjunto.nome } : {}),
        ...(selectedUnidade ? { unidade: selectedUnidade.id, nomeUnidade: selectedUnidade.nome } : {}),
        usuario: token.username,
        userNome: userData?.userName || "-",
      };
      const response = await execucoesService.executaFormV3(
        token,
        body,
        executionLease ? { executionLease: true } : undefined,
      );
      if (!response) throw new Error("Erro ao executar formulário");
      return response;
    }
  }
  if (!logado) {
    const params = decodeURIComponent(search as string)
      .replace(/[?]/g, "")
      .replace(/[ ]/g, "_")
      .replace(/[=]/g, "/")
      .split("&");
    const response = await anonimoService.executaChecklistAnonimo(
      {
        ...data,
        id: data?.id,
        inicio: inicio,
        fim: Date.now(),
      },
      params || [],
    );
    if (!response?.fim) throw new Error("Erro ao executar formulário");
    if (response?.fim) {
      return response;
    }
  }
}
